import { ProfileConstant } from '../constants';
import { RequestAction } from '.';

export const switchOffice = data =>
  RequestAction.request(ProfileConstant.SWITCH_OFFICE_PROFILE, {
    data,
    method: 'put',
    url: '/api/profile/switch-office',
  });
